import z from 'zod';
import { createIdSchema } from '../../lib/util/id.js';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { ExerciseInfoIdSchema } from '../exercise/exercise.types.js';
import { ExerciseComplexInfoIdSchema } from '../exercise-complex/exercise-complex.types.js';
import { metricCanonicalNames } from '../metric/metric.constants.js';
import { SectionPlanInfoIdSchema } from '../section/section.types.js';
import { stepPlanRepetitionModes } from './step.constants.js';
// ===== ID SCHEMAS =====
const StepPlanIdSchema = createIdSchema('stepPlan');
const StepPlanTableSelectSchema = createStrictSchema()({
    id: StepPlanIdSchema,
    sectionPlanId: SectionPlanInfoIdSchema,
    orderInSectionPlan: z.number(),
    // @todo: refine this so one of these is required
    exerciseId: ExerciseInfoIdSchema.nullable(),
    exerciseComplexId: ExerciseComplexInfoIdSchema.nullable(),
    repetitionMode: z.enum(stepPlanRepetitionModes),
    templateSets: z.number().int().nullable(),
    trackedMetrics: z.array(z.enum(metricCanonicalNames)).default([]),
    version: z.number().int().nonnegative(),
    notes: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const StepPlanInfoSchema = StepPlanTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
const StepPlanInfoIdSchema = StepPlanIdSchema;
export { StepPlanInfoIdSchema, StepPlanInfoSchema, StepPlanTableSelectSchema };
//# sourceMappingURL=step.types.js.map